/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Component } from "react";
import { observer } from "mobx-react";
import { SearchUIContainer } from "containers/search/SearchUIContainer";
import * as stores from "stores";
import { getShowSearchInHUD } from "selectors/hudSelectors";

@observer
class SearchUIMounter extends Component {
  render() {
    const shouldshowSearchInHud = getShowSearchInHUD(stores);
    return (
      <div>
        {/* mount the search "backend" component here */}
        {/* and ensure that only instance of it ever mounted */}
        {!shouldshowSearchInHud && stores.searchStore.numSearchWrapperComponentMounted === 0 ? (
          <SearchUIContainer
            style={{
              width: 0
            }}
          />
        ) : null}
      </div>
    );
  }
}

export { SearchUIMounter };
